import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/up-yong-logo-2.png'
import _imports_1 from '../assets/img/warning-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-14cc3ac5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "评论", -1))
const _hoisted_3 = {
  key: 0,
  class: "num"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "赞", -1))
const _hoisted_5 = {
  key: 0,
  class: "num"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bottom-btn" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("p", null, "在App中打开")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tip" }, "动态消失了", -1))

import TopDownLoadBanner from '@/components/TopDownLoadBanner.vue';
import ShareComment from '@/components/ShareComment.vue';
import SharePostContent from '@/components/SharePostContent.vue';
import { ref, onMounted } from 'vue';
import axios from 'axios';
import config from '../_config';
import { useRoute, useRouter } from 'vue-router';
import { formatWrap, formatEmotions } from '../lib';
import { Dialog } from 'vant';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const currentTab = ref(0);
const route = useRoute();
const router = useRouter();
const deleteFlag = ref(false);
const commentList = ref([]);
const showPoup = ref(false);
const showCatchTips = ref(false);
const articleDetail = ref({
  commentArticleCount: 0,
  collectArticleCount: 0
});

const goApp = () => {
  router.push({
    name: 'downLoad'
  });
};
onMounted(() => {
  const box = document.getElementById('html') as HTMLElement;
  box.style.fontSize = 'calc(100vw/3.75)';
});

const init = () => {
  // 本地测试 orgId为57    articleId 普通动态1374  点赞动态1373 跑步动态1372 已删除动态1376  户外跑1316（评论区空状态）
  const articleId = route.query.articleId || '';
  const orgId = route.query.orgId || '';
  const url = `app/free/share/dynamic/info?articleId=${articleId}&orgId=${orgId}`;
  axios
    .get(config.postDetailUrl + url)
    .then((res) => {
      console.log(res);
      const showDetail =
        res &&
        res.data &&
        res.data.code === 200 &&
        res?.data?.data?.articleDetailsResponse !== null;
      if (showDetail) {
        const data = res.data.data;
        const tempArticle = data.articleDetailsResponse || {};
        commentList.value = data.commentFirstQueryResponseList || [];
        tempArticle.content = formatWrap(tempArticle.content);
        tempArticle.content = formatEmotions(tempArticle.content);
        articleDetail.value = tempArticle;
        deleteFlag.value = false;
        showPoup.value = false;
      } else {
        // 已删除或其他无数据的帖子，展示动态消失弹窗
        deleteFlag.value = true;
        showPoup.value = true;
      }
    })
    .catch((_err) => {
      showCatchTips.value = true;
    });
};
init();

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: "share-bx bx",
    onClick: goApp
  }, [
    _createVNode(TopDownLoadBanner, { onDownload: goApp }),
    _createVNode(SharePostContent, {
      onClick: goApp,
      detail: articleDetail.value,
      isDelete: deleteFlag.value,
      onDownload: goApp
    }, null, 8, ["detail", "isDelete"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(['tab-item', currentTab.value === 0 && 'active']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (currentTab.value = 0))
      }, [
        _hoisted_2,
        (articleDetail.value?.commentArticleCount)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(articleDetail.value.commentArticleCount), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(['tab-item', currentTab.value === 1 && 'active']),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (currentTab.value = 1))
      }, [
        _hoisted_4,
        (articleDetail.value?.collectArticleCount)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(articleDetail.value.collectArticleCount), 1))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createVNode(ShareComment, {
      list: commentList.value,
      onDownload: goApp,
      showCatchTips: showCatchTips.value
    }, null, 8, ["list", "showCatchTips"]),
    _hoisted_6,
    _createVNode(_component_el_dialog, {
      modelValue: showPoup.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showPoup).value = $event)),
      class: "login-dialog",
      style: {"z-index":"9999999"},
      "close-on-click-modal": false,
      "show-close": false,
      top: "30vh",
      center: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", { class: "poup-box" }, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("p", {
            class: "poup-btn",
            onClick: goApp
          }, "确定")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})